<template>
  <div>
    <div class="loading-logo-box">
      <img class="loading-logo" src="@/assets/img/logo_loading.png" alt="">
      <div class="loading-tip">客户服务费</div>
    </div>
    <img class="loading-img" src="@/assets/img/loading.gif" alt="">
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import {CSF_REQUEST_SUCCESS_CODE} from '@/api/codeConstants.js'
import {mapMutations} from 'vuex'

import {logout, login} from '@/api/user'
import {getUserInfo} from '@/api/authorityManagement'
import {indexUrl} from '@/utils/login-url'
import {initAllMenu} from "@/common/common";
import {setCookies} from "@/utils/cookies-operations";

const logoutPath = Cookies.get('logoutPath') // 是否记录了登出页面地址
export default {
  name: 'loginSSoPage',
  data() {
    return {
      expires: 1,
      channelId: process.env.VUE_APP_CHANNELID,
    }
  },
  created() {
    this.loginFn();
  },
  mounted() {

  },
  methods: {
    ...mapMutations('account', ['setUser']),
    getQueryString(name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      const r = (window.location.href.indexOf('?') > -1) && window.location.href.split('?')[1].match(reg);
      if (r) {
        return unescape(r[2]);
      }
      return null;
    },
    // 普通登录
    async loginFn() {
      const m_tk = this.getQueryString('m_tk');
      if (m_tk) {
        login({m_tk: m_tk}).then(async p => {
          const res = p.data;
          if (res.code != 0) {
            this.$message.warning(res.message || res.msg || '出错了，请重新登录')
            setTimeout(() => {
              logout()
            }, 1000)
            return;
          }
          const {
            userName,
            jobNumber,
            userId,
            companyName,
            companyId,
          } = res.data
          this.userName = userName
          setCookies({jobNumber, userId,companyName,companyId}, {expires: this.expires})

          this.setUser({
            name: this.userName,
            jobNumber: jobNumber
          })
          await this.getLoginInfoFn(jobNumber, userId)
        })
      } else {
        this.$message.warning('登录已失效，请重新登录')
        setTimeout(() => {
          logout()
        }, 1000)
      }
    },
    async getLoginInfoFn(jobNumber, userId) {
      //初始化菜单
      await initAllMenu();

      //补全人员信息
      await this.getUserInfoByUserIdFn(jobNumber, userId);

      await this.loadIndexFn()
    },
    /*获取用户信息*/
    async getUserInfoByUserIdFn(jobNumber, userId) {
      const params = {
        queryParam: jobNumber,
        userId: userId
      }
      const result = await getUserInfo(params);
      const res = result.data;
      if (res.code === CSF_REQUEST_SUCCESS_CODE) {
        if (res.data.list.length === 0) {
          return;
        }
        const userInfo = res.data.list[0];
        this.userName = userInfo.userName
        Cookies.set('jobNumber', userInfo.jobNumber, {expires: this.expires});
        Cookies.set('userId', userInfo.userId, {expires: this.expires});
        Cookies.set('itemUserId', userInfo.itemUserId, {expires: this.expires});
        Cookies.set('userName', userInfo.userName, {expires: this.expires});
      }
    },
    /*跳转首页*/
    async loadIndexFn() {
      const page = this.getQueryString('page')
      location.replace(page || indexUrl)
    },
  }
}
</script>

<style lang="less" scoped>
.loading-logo-box {
  width: 266px;
  height: 238px;
  margin: 0 auto;
  margin-bottom: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -333px;
  margin-left: -119px;
}

.loading-tip {
  width: 256px;
  height: 42px;
  font-size: 32px;
  font-weight: bold;
  margin: 20px auto;
}

.loading-img {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -100px;
  margin-left: -100px;
}
</style>
